import React from 'react'
import Slider from 'react-slick'
import TranslationContext from '../../../utils/TranslationContext'
import { any } from 'prop-types'

import styles from './TestimonialsBanner.styl'

export default class TestimonialsBanner extends React.Component {

	static propTypes = {
		testimonials: any
	}

	static contextType = TranslationContext

	render() {
		const { testimonials } = this.props
		const { i18n } = this.context
		const reviews = (testimonials || []).map((ele, index) => {
			if (!ele.description) { return null }
			return (
				<div key={ index } className={ styles.row }>
					<div className={ styles.imgCol }>
						<div className={ styles.imgDiv }>
							<img src={ ele.images } alt="testemunha foto" className={ styles.img } />
						</div>
					</div>
					<div className={ styles.textContainer }>
						<p className={ styles.text } dangerouslySetInnerHTML={ { __html: ele.description } } />
						<h4 className={ styles.name }>{ ele.title }</h4>
					</div>
				</div>)
		}
		)
		const settings = {
			dots: false,
			className: `${ styles.slide }`,
			adaptiveHeight: true
		}
		return (
			<div id="testimonials" className={ styles['section'] }>
				<div className={ styles['content'] }>
					<h1>{ i18n`testimonials_label` }</h1>
					<Slider { ...settings }>
						{ reviews.length > 0 ? reviews : <div /> }
					</Slider>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/components/TestimonialsBanner/TestimonialsBanner.js